/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class PXPMain {
  async Transform(htmlStream : any) : Promise<any> {
    return await componentApi.call('pxp', 'PXPMain', 'PXPMain', 'Transform', {
      htmlStream,
    });
  }
}
export default new PXPMain()
